import './CoralBadge.scss'

import React from 'react'

type CoralBadgeProps = {
  backgroundColor?: string
  fontSize?: string
  radius?: number
  absolutePosition?: string
  text: string
}
export const CoralBadge: React.FC<CoralBadgeProps> = (props) => {
  return (
    <div
      className={`coral-badge m--radius-${props.radius} m--absolute-position-${props.absolutePosition} m--color-${props.backgroundColor} m--size-${props.fontSize}`}
    >
      {props.text}
    </div>
  )
}
